import moment from "moment";
import * as React from "react";
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

export const RenderGraphGmtInfo: React.FC<{}> = (props) => {
    const { t } = useTranslation();
    var currentDate = moment().utc();
    const now = moment();
    const dateInfo = currentDate.day() != now.day() ? `(${currentDate.format("LL")})` : "";

    return <div>{`${t("Views.Dashboards.Components.RenderGraphGmtInfo.Text")} ${currentDate.format("HH:mm")}h ${dateInfo}`}</div>;
};